import { memo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'
import { useCommonProjectManagementData } from 'shared/hooks/useCommonProjectManagementData'
import { useCommonStore } from 'shared/stores/commonStore'

import { useAvailableApps } from '../hooks/useAvailableApps'

const ProjectManagementAppV2 = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const history = useHistory()
    const { user } = useUserContext()
    const isInternalUser = useCommonStore(state => state.isInternalUser)
    const { apps } = useAvailableApps()

    const { user: extendedUser } = useCommonProjectManagementData()

    return (
      <FullPageAppTemplate
        appId={AppId.PROJECT_MANAGEMENT_V2}
        scope='project_management_v2'
        envKey={apps[AppId.PROJECT_MANAGEMENT_V2]?.runtimeEnvKey}
        entryPath='./ProjectManagementV2App'
        url={process.env.REACT_APP_PROJECT_MANAGEMENT_V2_APP_DEV_PATH}
        appName={apps[AppId.PROJECT_MANAGEMENT_V2]?.name}
        appProps={{
          user,
          extendedUser,
          defaultHistory: history,
          initialPath: apps[AppId.PROJECT_MANAGEMENT_V2].path,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location

            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          },
          isInternalUser: isInternalUser([], true)
        }}
      />
    )
  },
  () => true
)

export { ProjectManagementAppV2 }
